/**
 * WindowTokens module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

export const setup = (): void => {
    /**
     * Use Window Token from session storage in header for every request
     * If there is no Window Token in session storage add RequestWindowToken header
     * which is resolved in middleware
     */
    axios.interceptors.request.use(
        (config) => {
            if (sessionStorage.windowToken) {
                config.headers['WindowToken'] = sessionStorage.windowToken;
            } else {
                config.headers['RequestWindowToken'] = true;
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        },
    );

    /**
     * Check for Window Token in every response
     * If Window Token is present, store it to the session storage
     */
    axios.interceptors.response.use(
        (response) => {
            if (response.headers['windowtoken']) {
                sessionStorage.windowToken = response.headers['windowtoken'];
            }

            return response;
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};
